import { ApplicationStatus } from "shared/types";
import { ApplicantRoleLabel } from "shared/utils";
import { RoleTitles } from "views/settings-users/slices/users/constants";

export const applicationDecisionStatus = {
  [ApplicationStatus.Rejected]: "Application rejected",
  [ApplicationStatus.Approved]: "Application approved",
  [ApplicationStatus.ConditionalApproved]: "Application approved conditionally"
};

export const AGENT_AUTHOR_ROLE = "ai_agent" as const;

export const AGENT_ACTIVITY_TYPES = [
  "agent_escalation_detected",
  "agent_action_taken",
  "agent_escalated_to_support",
  "agent_escalation_reviewed"
] as const;

export const combinedRoles = {
  ...RoleTitles,
  ...ApplicantRoleLabel,
  [AGENT_AUTHOR_ROLE]: "AI Agent"
};
